// src/theme.ts
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#e67e22", // More muted orange (was #ff8c00)
      light: "#f39c12",
      dark: "#d35400",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#2e7d32", // Green
      light: "#4caf50",
      dark: "#1b5e20",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f9f9f9",
    },
    // Override default blue colors where they might appear
    info: {
      main: "#e67e22", // Using primary orange for info instead of default blue
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    button: {
      textTransform: "none",
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
        containedPrimary: {
          "&:hover": {
            backgroundColor: "#d35400",
          },
        },
        containedSecondary: {
          "&:hover": {
            backgroundColor: "#1b5e20",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 12,
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: "#e67e22",
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#f39c12",
        },
        barColorPrimary: {
          backgroundColor: "#d35400",
        },
      },
    },
    MuiLink: {
      defaultProps: {
        underline: "hover",
      },
      styleOverrides: {
        root: {
          color: "#d35400", // Using orange for links instead of blue
          "&:hover": {
            color: "#e67e22",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#e67e22",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#2e7d32",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: "#2e7d32",
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#e67e22",
          "&.Mui-checked": {
            color: "#e67e22",
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#e67e22",
          "&.Mui-checked": {
            color: "#e67e22",
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          "&.Mui-checked": {
            color: "#e67e22",
            "& + .MuiSwitch-track": {
              backgroundColor: "#e67e22",
            },
          },
        },
      },
    },
  },
});

export default theme;
